// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".billing-footer[data-v-a311d994]{height:90px}.billing_button[data-v-a311d994]{transition:box-shadow .2s}.billing_button[data-v-a311d994]:hover{box-shadow:0 4px 16px rgba(112,149,235,.18)}.text-color-billing[data-v-a311d994]{color:hsla(0,0%,100%,.6)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
